
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/about",
      function () {
        return require("private-next-pages/download/about/index.tsx");
      }
    ]);
  